import React from 'react';
import { array, func, object } from 'prop-types';
import { List } from '@mui/material';
import AcknowledgeListItem from './AcknowledgeListItem';

const AcknowledgeList = ({ employees, acknowledges, message, onSend }) => {
  const handleSend = employee => () => {
    onSend(employee);
  };

  return (
    <List>
      {employees.map((employee, index) => (
        <AcknowledgeListItem
          key={employee._id}
          selected={!!(index % 2)}
          employee={{
            ...employee,
            confirmedAt: acknowledges.find(a => a.user === (employee.user_id || employee.user?._id))
              ?.confirmedAt,
          }}
          onSend={handleSend(employee)}
          message={message}
        />
      ))}
    </List>
  );
};

AcknowledgeList.propTypes = {
  employees: array.isRequired,
  acknowledges: array.isRequired,
  message: object.isRequired,
  onSend: func.isRequired,
};

export default AcknowledgeList;
